<template>

  <div class="all">
    <headercon></headercon>
    <div class="anniu">
      <img :src="img1"
           alt=""
           @click="go"
           class="button">
      <div class="info">
        <div class="leftView">
          <p class="name">裴涛</p>
          <p class="des">1979年生于湖北宜昌，2001年毕业于湖北大学国家教育部文科基地班。</p>
          <p class="des">2001年9月-2016年，任某主板上市公司总裁助理、监事会主席等职。</p>
          <p class="des">2014年4月创办湖北云雷信息技术有限公司（原湖北云雷文化传播有限公司），任董事长兼总经理，致力于移动互联网业务及大数据应用项目的开发及运营。</p>
          <p class="des">2017年，受聘于中南民族大学文学与新闻传播学院，兼任中南民族大学中国数字人文资源研究中心客座教授。</p>
          <p class="title">主要成就</p>
          <p class="des">2001年9月-2016年期间，承担过科技部国家高技术研究发展计划（863计划）、文化部国家文化科技提升计划、国家发改委信息安全专项、工信部“数字家庭”项目在内的多项国家级、省、市级项目。</p>
          <p class="subject">科技部国家高技术研究发展计划（863计划）</p>
          <p class="subject">所属课题：基于高可信网络的数字内容服务系统开发及示范</p>
          <p class="subject">课题名称：“科技院线”栏目视频节目制作</p>
          <p class="subject">文化部国家文化科技提升计划</p>
          <p class="subject">课题名称：中国戏曲海外传播推送服务平台构建</p>
          <p class="subject">国家发改委信息安全专项</p>
          <p class="subject">课题名称：三网融合数据安全管理系统产业化</p>
          <p class="subject">工信部“数字家庭”项目</p>
          <p class="subject">课题名称：数字家庭产业集聚区10万户级示范应用</p>
        </div>
        <div class="rightView">
          <p class="subTitle">个人荣誉</p>
          <div class="honourView">
            <div class="honour" v-for="(item, index) in honour" :key="index">
              <img :src="item.img"/>
              <p>{{item.text}}</p>
            </div>
          </div>
          <p class="des">2016年，由武汉大学校长、院士及政府部门推荐，获得国家自主创新区“3551人才”奖，个人获得壹佰万奖励。</p>
          <div class="prizeView">
            <img src="../assets/honour5.png"/>
            <img src="../assets/honour6.png"/>
            <img src="../assets/honour7.png"/>
          </div>
          <p class="subTitle">文学成就</p>
          <p class="des">2008年“中国青年诗人峰会”一等奖；2012年“全球华人华裔文言大赛”探花奖；</p>
          <div class="bookView">
            <div class="left">
              <p class="subTitle">出版图书</p>
              <p class="subject">《网络诗坛点将录》：中国文联出版社2011年11月出版</p>
              <p class="subject">《将进酒》：上海社会科学院出版社2015年6月出版</p>
              <p class="subject">《客行集》：上海社会科学院出版社2019年12月出版</p>
            </div>
            <div class="right">
              <img src="../assets/book1.png"/>
              <img src="../assets/book2.png"/>
              <img src="../assets/book3.png"/>
            </div>
          </div>
        </div>
      </div>
      <img :src="img2"
           alt=""
           @click="go1"
           class="button1">
    </div>
  </div>
</template>

<script>
import headercon from './header'
export default {
  components: {
    headercon
  },
  data () {
    return {
      img: require('../assets/componylogo.png'),
      img1: require('../assets/buttonl.png'),
      img2: require('../assets/buttonr.png'),
      text: '首页',
      text1: '产品与服务',
      text2: '企业动态',
      text3: '资质荣誉',
      text4: '关于我们',
      honour: [
        {img: require('../assets/honour1.png'), text: '国家广电总局科技创新奖'},
        {img: require('../assets/honour2.png'), text: '王选新闻科学技术奖'},
        {img: require('../assets/honour3.png'), text: '中国电影电视技术学会科学技术奖'},
        {img: require('../assets/honour4.png'), text: '湖北省科技进步奖'},
      ],
    }
  },
  methods: {

    go () {
      this.$router.push({ path: '/recruit' })
    },
    go1 () {
      this.$router.push({ path: '/aboutus' })
    }

  }
}
</script>

<style scoped lang="less">
  .all {
    background: url("../assets/founder_bg.png");
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    min-width: 1199px;
    /deep/ .li5 {
      list-style-type: none;
      float: left;
      border-radius: 25px;
      background: #fff;
      width: 100px;
      height: 30px;
      text-decoration: none;
      text-align: center;
      line-height: 30px;
      a {
        color: #757575;
        text-decoration: none;
      }
    }
    .anniu {
      display: flex;
      width: 100%;
      height: 80%;
      .button {
        margin-top: 19.5%;
        margin-left: 3%;
        width: 2%;
        height: 20%;
        text-align: center;
        line-height: 28px;
        background: linear-gradient(to right, #d5edfb, #eeffff);
        border: none;
        font-size: 80px;
        color: #62c3d0;
      }
    }
  }
  @media only screen and (min-width: 1781px) {
    .button1 {
      position: absolute;
      right: 3%;
      margin-top: 19.5%;
      width: 2%;
      height: 15%;
      text-align: center;
      line-height: 28px;
      background: linear-gradient(to left, #d5edfb, #eeffff);
      border: none;
      font-size: 80px;
      color: #62c3d0;
    }
  }
  @media only screen and (min-width: 1601px) and (max-width: 1780px) {
    .button1 {
      position: absolute;
      right: 3%;
      margin-top: 19.5%;
      width: 2%;
      height: 15%;
      text-align: center;
      line-height: 28px;
      background: linear-gradient(to left, #d5edfb, #eeffff);
      border: none;
      font-size: 80px;
      color: #62c3d0;
    }
  }
  @media only screen and (min-width: 1421px) and (max-width: 1600px) {
    .button1 {
      position: absolute;
      right: 3%;
      margin-top: 19.5%;
      width: 2%;
      height: 15%;
      text-align: center;
      line-height: 28px;
      background: linear-gradient(to left, #d5edfb, #eeffff);
      border: none;
      font-size: 80px;
      color: #62c3d0;
    }
  }
  @media only screen and (min-width: 1200px) and (max-width: 1420px) {
    .button1 {
      position: absolute;
      right: 3%;
      margin-top: 19.5%;
      width: 2%;
      height: 15%;
      text-align: center;
      line-height: 28px;
      background: linear-gradient(to left, #d5edfb, #eeffff);
      border: none;
      font-size: 80px;
      color: #62c3d0;
    }
  }
  @media only screen and (max-width: 1200px) {
    .anniu {
      position: relative;
      .button1 {
        position: absolute;
        left: 1100px;
        top: 230px;
        width: 24px;
        height: 73px;
        text-align: center;
        line-height: 28px;
        background: linear-gradient(to left, #d5edfb, #eeffff);
        border: none;
        font-size: 80px;
        color: #62c3d0;
      }
    }
  }

  .info {
    margin-left: 5%;
    top: 18%;
    height: 75%;
    width: 80%;
    position: relative;
    overflow-y: scroll;
    display: flex;

    p {
      display: block;
      margin-block-start: 0 !important;
      margin-block-end: 0 !important;
    }

    .leftView {
      width: 50%;
      padding-right: 50px;
      text-align: left;
    }

    .rightView {
      width: 50%;
      padding-left: 50px;
      text-align: left;
    }

    .name {
      color: #750a83;
      font-size: 20px;
      font-weight: bold;
      padding-bottom: 10px;
    }

    .des {
      color: #2c3e50;
      font-size: 15px;
      padding-bottom: 6px;
    }

    .title, .subTitle {
      color: #750a83;
      font-size: 16px;
      font-weight: bold;
      padding-top: 30px;
      padding-bottom: 10px;
    }

    .subTitle {
      padding-bottom: 5px;
      padding-top: 0;
    }

    .subject {
      color: #2c3e50;
      font-size: 13px;
      padding-bottom: 6px;
    }

    .honourView {
      display: flex;
      align-content: center;
      margin-bottom: 10px;
      justify-content: space-between;

      .honour {
        width: 23%;
        height: 140px;
        text-align: center;

        img {
          width: 100%;
          height: 100px;
          object-fit: contain;
        }

        p {
          color: #2c3e50;
          font-size: 12px;
          margin-top: 20px;
          line-height: 20px;
        }
      }
    }

    .prizeView {
      margin-top: 8px;
      margin-bottom: 8px;
      display: flex;
      align-content: center;
      justify-content: space-around;

      img {
        width: 25%;
        height: 100px;
        object-fit: contain;
      }
    }

    .bookView {
      margin-top: 15px;
      display: flex;

      .left {
        width: 50%;
      }

      .right {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: space-around;

        img {
          width: 30%;
          height: 100px;
          object-fit: contain;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/founder.vue